export default function Header(props) {
    return (
        <div className='header'>
            <h1 className='header--title'>Hi! I'm {props.name}</h1>
            <h2 className='header--subtitle'>Let's talk!</h2>
        </div>
    )
}
